import { render, staticRenderFns } from "./opened-player.vue?vue&type=template&id=e10ade26&"
import script from "./opened-player.vue?vue&type=script&lang=js&"
export * from "./opened-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports